import { render, staticRenderFns } from "./EmployeeClassificationForm.vue?vue&type=template&id=efab2e24&"
import script from "./EmployeeClassificationForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeClassificationForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeClassificationForm.vue?vue&type=style&index=0&id=efab2e24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports